import React, { useState, useRef, useEffect } from "react";
import "./EllipsesDropdown.scoped.scss";

export interface IEllipsesDropdownItem {
  key: string,
  label: string | React.ReactElement,
  disable?: boolean,
  toolTip?: string,
  icon?: string,
  onClick?(): void,
}

interface IEllipsesDropdownProps {
  label?: string,
  icon?: string,
  itemTextAlign?: "left" | "center" | "right",
  items: (IEllipsesDropdownItem | undefined)[],
  children?: any
}

const EllipsesDropdown: React.FC<IEllipsesDropdownProps> = ({
  label,
  icon,
  items,
  itemTextAlign,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleDocumentClick(event: MouseEvent) {

      if (!containerRef.current
        || !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleDocumentClick);

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [containerRef, setIsOpen]);

  const toggleMenu = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  }

  const itemClick = (item: IEllipsesDropdownItem) => {
    if (item.onClick) {
      item.onClick();
    }

    setIsOpen(false);
  }

  return (
    <div
      className="container"
    >
      {children ? <button className="child-button" onClick={(e) => toggleMenu(e)}>{children}</button> : <button
        className={`secondary-button toggle-button ${isOpen ? "open" : ""}`}
        onClick={(e) => toggleMenu(e)}
      >
        {icon &&
          <img
            src={icon}
            alt=""
            className="icon-small"
          />
        }
        {label || "⋮"}
      </button>}

      <div
        className={`dropdown-menu ${isOpen ? "open" : ""} align-${itemTextAlign || "center"}`}
        ref={containerRef}
      >
        {items.map(i => i === undefined
          ? undefined
          : (
            <button
              className="secondary-button item"
              key={i.key}
              title={i.toolTip ? i.toolTip : i.key}
              disabled={i.disable}
              onClick={(e) => {
                e.preventDefault();
                itemClick(i);
              }}
            >
              {i.icon &&
                <img
                  src={i.icon}
                  alt=""
                  className="icon-small"
                />
              }
              {i.label}
            </button>
          ))}
      </div>
    </div>
  );
};

export default EllipsesDropdown;